import React, { useEffect, useState } from "react";
import { useSubheader } from "../../../../../_metronic/layout";
import Invoicing from "./Invoicing";
import Payout from "./Payout";
import PharmaciesInvoicing from "./PharmaciesInvoicing";
import DriverBillsTable from "../managedrivers/driver-details/DriverBillsTable";
import { Card, CardBody } from "../../../../../_metronic/_partials/controls";
import MasterInvoiceHistory from "../managemasterinvoice/admins-details/MasterInvoiceHistory";
import { GetRole } from "../../../../../_metronic/_helpers/GlobalHelpers";
import ExportDataPage from "./ExportDataPage";

const TransactionManagement = () => {
  const suhbeader = useSubheader();
  suhbeader.setTitle("Billing Management");
  const [key, setKey] = useState(1);

  useEffect(() => {
    if(GetRole() === "Accord Financial"){
      setKey(3);
    }
  }
  , []);

  return (
    <div className="row">
      <div className="col-12">
        <div className="card-header pb-0 pt-2 border-0">
          <ul
            className="nav nav-dark nav-bold nav-tabs nav-tabs-line"
            data-remember-tab="tab_id"
            role="tablist"
          >
           {GetRole() !== "Accord Financial" &&
          <>
            <li className="nav-item">
              <a
                style={{ cursor: "pointer" }}
                className={`nav-link font-size-h5 ${
                  key === 1 ? "active font-weight-bolder" : ""
                }`}
                data-toggle="tab"
                onClick={() => {
                  setKey(1);
                }}
              >
                Accounts receivable
              </a>
            </li>
            <li className="nav-item">
              <a
                style={{ cursor: "pointer" }}
                className={`nav-link font-size-h5 ${
                  key === 2 ? "active font-weight-bolder" : ""
                }`}
                data-toggle="tab"
                onClick={() => {
                  setKey(2);
                }}
              >
                Accounts payable
              </a>
            </li>
            </>}
            <li className="nav-item">
              <a
                style={{ cursor: "pointer" }}
                className={`nav-link font-size-h5 ${
                  key === 3 ? "active font-weight-bolder" : ""
                }`}
                data-toggle="tab"
                onClick={() => {
                  setKey(3);
                }}
              >
                Invoices
              </a>
            </li>
           {GetRole() !== "Accord Financial" && <li className="nav-item">
              <a
                style={{ cursor: "pointer" }}
                className={`nav-link font-size-h5 ${
                  key === 4 ? "active font-weight-bolder" : ""
                }`}
                data-toggle="tab"
                onClick={() => {
                  setKey(4);
                }}
              >
               Bills
              </a>
            </li>}
            <li className="nav-item">
              <a
                style={{ cursor: "pointer" }}
                className={`nav-link font-size-h5 ${
                  key === 5 ? "active font-weight-bolder" : ""
                }`}
                data-toggle="tab"
                onClick={() => {
                  setKey(5);
                }}
              >
               Master Invoices
              </a>
            </li>
            <li className="nav-item">
              <a
                style={{ cursor: "pointer" }}
                className={`nav-link font-size-h5 ${
                  key === 6 ? "active font-weight-bolder" : ""
                }`}
                data-toggle="tab"
                onClick={() => {
                  setKey(6);
                }}
              >
               Export Data
              </a>
            </li>
          </ul>
        </div>
        {key === 1 && (
          <div className="card card-custom Store-sticky">
            <Invoicing />
          </div>
        )}
        {key === 2 && (
          <div className="card card-custom Store-sticky">
            <Payout />
          </div>
        )}
        {key === 3 && (
          <div className="card card-custom Store-sticky">
            <PharmaciesInvoicing />
          </div>
        )}
        {key === 4 && (
          <div className="card card-custom Store-sticky">
               <Card>
                  <CardBody>
                    <DriverBillsTable isBills={true} />
                  </CardBody>
               </Card>
          </div>
        )}
          {key === 5 && (
          <div className="card card-custom Store-sticky">
            <Card>
              <CardBody>
               <MasterInvoiceHistory isMaster={false} />
            </CardBody>
            </Card>
          </div>
        )}
          {key === 6 && (
          <div className="card card-custom Store-sticky">
            <Card>
              <CardBody>
               <ExportDataPage />
            </CardBody>
            </Card>
          </div>
        )}
      </div>
    </div>
  );
};

export default TransactionManagement;
